import * as React from "react";
import { useState } from 'react';
import { useDataProvider, useNotify, useRefresh, Button } from 'react-admin';

export const PublishButton = ({ record }) => {
    const notify = useNotify();
    const dataProvider = useDataProvider();
    const myrefresh = useRefresh();
    const [loading, setLoading] = useState(false);
    if (!record) return null;
    if (record.published === true) {
      return <Button label="Publish" disabled={true} />;
    }
    const publish = () => {
      setLoading(true);
      dataProvider
        .publish('posts', { id: record.id })
        .then(response => {
            setLoading(false);
            myrefresh();
            notify('Post published');
        })
        .catch(error => {
            setLoading(false);
            notify('Something went wrong!');
        });
      }
    return <Button label="Publish" onClick={publish} disabled={loading} />;
};
